import React from 'react';
import { Main } from 'fragments';
import { AbaBillingSoftwareFragment } from './fragments';

export const AbaBillingSoftware = () => {

    return (
        <Main>
            <AbaBillingSoftwareFragment />
        </Main>
    );
};
